import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet";

const Privacy = () => {
  const title = "Politique de Confidentialité | NLocale - Découvrez l'Aisne Autrement";
  const description = "Politique de confidentialité de NLocale. Découvrez comment nous protégeons vos données personnelles et respectons votre vie privée.";
  const canonicalUrl = "https://onarrivebientot.nlocale.fr/confidentialite";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": canonicalUrl,
    "mainEntity": {
      "@type": "PrivacyPolicy",
      "name": "Politique de Confidentialité NLocale",
      "dateModified": new Date().toISOString().split('T')[0]
    }
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href={canonicalUrl} />
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-12">
        <div className="container max-w-3xl mx-auto px-4">
          <Link to="/">
            <Button variant="ghost" className="mb-8">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour
            </Button>
          </Link>

          <h1 className="text-4xl font-bold mb-8">Politique de Confidentialité</h1>

          <div className="prose prose-blue max-w-none">
            <p className="text-lg mb-6">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
              <p>
                NLocale s'engage à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles lorsque vous utilisez notre service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. Informations que nous collectons</h2>
              <p>Nous collectons les informations suivantes :</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone (optionnel)</li>
                <li>Nom de l'entreprise (pour les professionnels)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Utilisation des informations</h2>
              <p>Nous utilisons vos informations pour :</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Vous informer du lancement de notre service</li>
                <li>Vous contacter concernant votre inscription</li>
                <li>Améliorer notre service</li>
                <li>Respecter nos obligations légales</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">4. Protection des données</h2>
              <p>
                Nous prenons la sécurité de vos données très au sérieux. Nous utilisons des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos informations personnelles contre tout accès, modification, divulgation ou destruction non autorisée.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">5. Vos droits</h2>
              <p>Vous avez le droit de :</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Accéder à vos données personnelles</li>
                <li>Rectifier vos données</li>
                <li>Demander la suppression de vos données</li>
                <li>Vous opposer au traitement de vos données</li>
                <li>Retirer votre consentement à tout moment</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">6. Contact</h2>
              <p>
                Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, vous pouvez nous contacter à : <a href="mailto:bonjour@presencelocale.fr" className="text-primary hover:underline">bonjour@presencelocale.fr</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
